import type { RunnerRetryConfig } from "./types.ts";

export const MAX_RUNNER_RETRY_ATTEMPTS = 10;
export const MAX_RUNNER_RETRY_BACKOFF_MS = 60_000;

export function parseRunnerRetryConfig(value: unknown, field: string): RunnerRetryConfig | undefined {
	if (value === undefined) return undefined;
	if (!value || typeof value !== "object" || Array.isArray(value)) {
		throw new Error(`${field} must be an object.`);
	}
	const retry = value as Record<string, unknown>;
	const unknown = Object.keys(retry).filter((key) => key !== "maxAttempts" && key !== "backoffMs");
	if (unknown.length > 0) throw new Error(`${field} has unsupported fields: ${unknown.join(", ")}.`);
	const maxAttempts = retry.maxAttempts;
	if (
		typeof maxAttempts !== "number" ||
		!Number.isInteger(maxAttempts) ||
		maxAttempts < 1 ||
		maxAttempts > MAX_RUNNER_RETRY_ATTEMPTS
	) {
		throw new Error(
			`${field}.maxAttempts must be an integer from 1 to ${MAX_RUNNER_RETRY_ATTEMPTS}.`,
		);
	}
	const backoffMs = retry.backoffMs;
	if (
		backoffMs !== undefined &&
		(typeof backoffMs !== "number" ||
			!Number.isInteger(backoffMs) ||
			backoffMs < 0 ||
			backoffMs > MAX_RUNNER_RETRY_BACKOFF_MS)
	) {
		throw new Error(`${field}.backoffMs must be an integer from 0 to ${MAX_RUNNER_RETRY_BACKOFF_MS}.`);
	}
	return {
		maxAttempts,
		...(backoffMs !== undefined ? { backoffMs } : {}),
	};
}
